export function closeDialogsBeforeCache() {
  document.addEventListener('turbo:before-cache', () => {
    document.querySelectorAll('dialog[open]').forEach(d => d.close());
  });
}
